import { render, staticRenderFns } from "./gestioneNews.html?vue&type=template&id=66ffff0f&external"
import script from "./GestioneNews.vue?vue&type=script&lang=js"
export * from "./GestioneNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports